<template>
  <header class="header">
    <section class="header__section">
      <h1 class="header__section--title">
        <router-link :to="{ path: `/${langPath}` }">
          <img
            src="../../assets/images/logo.svg"
            class="margin-right12"
            alt="TMF VIRTUAL RUN TOKYO MARATHON FOUNDATION"
            width="295"
            height="42"
          />
        </router-link>
      </h1>
      <div class="header__section--block">
        <router-link
          v-if="!isLogin"
          :to="{ path: `/${langPath}company/login` }"
          class="login-link flex-all-center"
        >
          {{ headerJson.login[lang] }}
        </router-link>
        <router-link
          v-if="isLogin"
          :to="{ path: `/${langPath}company/summary` }"
          class="login-link flex-all-center"
        >
          {{ headerJson.company[lang] }}
        </router-link>
        <router-link
          :to="{ path: `/${langPath}confirmation` }"
          class="confirm-link flex-all-center"
        >
          {{ headerJson.oauth[lang] }}
        </router-link>
        <!-- ログイン画面時は英語切り替えを表示しない -->
        <ul
          class="header__section--block__list"
          v-if="
            !$route.path.includes('confirmation') ||
            !$route.path.includes('login')
          "
        >
          <li class="list-item" :class="{ active: isJaActive }">
            <a :href="`/${switchLangPath}`" class="link flex-all-center">
              JP
            </a>
          </li>
          <li class="list-item" :class="{ active: isEnActive }">
            <a :href="`/en/${switchLangPath}`" class="link flex-all-center">
              EN
            </a>
          </li>
        </ul>
      </div>
    </section>
    <ul class="header__link--list">
      <li class="header__link--list__item">
        <router-link :to="{ path: `/${langPath}howtojoin` }" class="link">
          How to Join
        </router-link>
      </li>
      <li class="header__link--list__item">
        <router-link
          v-if="this.$route.path === `/${langPath}`"
          v-scroll-to="'#event-section'"
          to=""
          class="link"
        >
          Event
        </router-link>
        <!-- top以外から遷移してきた時にもスクロールさせたい -->
        <router-link
          v-else
          :to="{ path: `/${langPath}`, query: { from: 'htj' } }"
          class="link"
          >Event</router-link
        >
      </li>
      <li class="header__link--list__item">
        <router-link :to="{ path: `/${langPath}result` }" class="link">
          Results
        </router-link>
      </li>
      <li class="header__link--list__item last">
        <router-link :to="{ path: `/${langPath}question` }" class="link">
          FAQ
        </router-link>
      </li>
    </ul>
  </header>
</template>

<script>
import header from "../../assets/constants/header";
import cognito from "../../plugins/cognito";
export default {
  data() {
    return {
      isJaActive: this.$route.path.split("/")[1] !== "en",
      isEnActive: this.$route.path.split("/")[1] === "en",
      switchLangPath:
        this.$route.path.split("/")[1] === "en"
          ? this.$route.fullPath.split("/").slice(2).join("/")
          : this.$route.fullPath.split("/").slice(1).join("/"),
      isLogin: false,
    };
  },
  created() {
    this.isLogin = cognito.getUserName();
  },
  computed: {
    headerJson: function () {
      return header;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  name: "CommonHeader",
};
</script>

<style scoped lang="scss">
.header {
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.16);
  position: relative;
  &::before {
    content: "";
    display: block;
    height: 5px;
    background: url("../../assets/images/border/border_header_pc.svg") center;
  }
  &__section {
    padding: 21px 0 0 0;
    width: 1000px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    /*productionでビルドした時だけvuetifyのスタイルが優先されてしまうため*/
    &--title {
      margin: 0;
    }

    &--block {
      display: flex;

      .login-link {
        width: 200px;
        height: 30px;
        border: solid 1px #000;
        font-weight: bold;
        &:hover {
          color: #fff;
          background-color: #000;
        }
      }

      .confirm-link {
        margin: 0 0 0 30px;
        width: 240px;
        height: 30px;
        border: solid 1px #000;
        font-weight: bold;
        &:hover {
          color: #fff;
          background-color: #000;
        }
      }

      &__list {
        display: flex;
        margin: 0 0 0 30px;
        padding: 0 0 0 30px;
        border-left: solid 1px #000;

        .list-item {
          width: 30px;
          height: 30px;
          border: solid 1px #000;
          font-size: 18px;
          font-weight: bold;

          .link {
            width: 100%;
            height: 100%;
          }

          &:hover {
            background-color: #000;
            .link {
              color: #fff;
            }
          }

          &:not(:first-of-type) {
            margin: 0 0 0 5px;
          }
        }

        .active {
          background-color: #000;

          .link {
            color: #fff;
          }
        }
      }
    }
  }
  &__link--list {
    width: 1000px;
    margin: 32px auto 0 auto;
    display: flex;
    &__item {
      flex: 1;
      text-align: center;
      .link {
        display: block;
        padding: 0 60px 21px 60px;
        font-size: 22px;
        font-weight: bold;
        border-bottom: solid 3px transparent;
        &:hover {
          border-bottom: solid 3px #000;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/CommonHeader.vue